import { Badge, Text } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { type TranslatedAppFeature } from 'domains/role-management/components/role-assigned-permissions/usePermissionsDictionary'
import { useShowSlugsContext } from 'domains/role-management/components/show-slugs-provider/RoleManagementShowSlugsProvider'
import { NewBadge } from 'gin-and-tonic/common/badges/NewBadge'

interface RoleManagementFeatureDetailsProps {
  feature: TranslatedAppFeature
}

const FeatureDetails = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
})

const FeatureDetailsName = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
})

export const RoleManagementFeatureDetails: FunctionComponent<RoleManagementFeatureDetailsProps> = ({
  feature,
}) => {
  const showSlugs = useShowSlugsContext()

  return (
    <div>
      <FeatureDetails data-testid={feature.featureName}>
        <FeatureDetailsName>
          <Text>{feature.featureName}</Text>
          {feature.isNewPermission && <NewBadge />}
        </FeatureDetailsName>
        <Text>{feature.permissions.map(perm => perm.label).join(', ')}</Text>
      </FeatureDetails>
      <SecondRow>
        <Text size="small">{feature.description}</Text>
        {showSlugs && (
          <SlugsContainer>
            {feature.permissions.map(perm => (
              <Badge color="grey" key={perm.slug}>
                {perm.slug}
              </Badge>
            ))}
          </SlugsContainer>
        )}
      </SecondRow>
    </div>
  )
}

const SecondRow = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
})

const SlugsContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  paddingTop: 4,
  fontFamily: 'monospace',
})
